import { FC } from 'react';
import { InvoiceArchiveDownload } from 'components/InvoiceArchiveDownload';
import { Page } from 'layouts/Page';

export const InvoiceArchiveDownloadPage: FC = () => {
	return (
		<Page title="Download Invoice Archive – EAS Control Center">
			<InvoiceArchiveDownload />
		</Page>
	);
};
